import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Observable, Subscription, filter } from 'rxjs';
import { TableLazyLoadEvent } from 'primeng/table';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import * as UserFileActions from 'src/app/store/user-file/user-file.actions';
import { pageSortChange } from 'src/app/services/table';
import { Tooltip } from 'primeng/tooltip';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { ExportInfo } from 'src/app/model/export';
import { EXPORT_LIST_DEFAULT_SORT_COLUMN, EXPORT_LIST_DEFAULT_SORT_COLUMN_DIRECTION, EXPORT_LIST_PAGE_DEFAULT_SIZE, EXPORT_LIST_PAGE_SIZE_OPTIONS } from 'src/app/conf/export';
import { MtmaImportDeviceDialogComponent } from '../mtma-import-dialog/mtma-import-dialog.component';
import { MtmaExportDeviceDialogComponent } from '../mtma-export-dialog/mtma-export-dialog.component';
import { selectDeletedMtmaExportDevice, selectExportedMtmaDevice, selectExportMtmaDeviceList, selectExportMtmaDeviceListLoading, selectExportMtmaDevicePaging, selectUpdatedMtmaExportDevice } from 'src/app/store/user-file/user-file.selector';
import { selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import { selectMtmaExportData } from 'src/app/store/device/device.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { exportToCsvWithInfoColumn } from 'src/app/modules/shared/utils/exportData';
import { MtmaExportData, MtmaExportRow } from 'src/app/model/mtma-import-export-file';
import { User } from 'src/app/model/user';

@Component({
	selector: 'app-mtma-import-export-list',
	templateUrl: './mtma-import-export-list.component.html',
	providers: []
})

export class MtmaImportExportListComponent implements OnInit, OnDestroy {

	exportList: ExportInfo[];
	exportList$: Observable<ExportInfo[] | undefined>;
	exportListSub: Subscription | undefined;

	exportListLoading: boolean;
	exportListLoading$: Observable<boolean | undefined>;
	exportListLoadingSub: Subscription | undefined;

	exportListPaging$: Observable<ItemsPagination | undefined>;
	exportListPagingSub: Subscription | undefined;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;
	isImpersMode: boolean;

	update$: Observable<boolean | undefined>;
	updateSub: Subscription;
	delete$: Observable<boolean | undefined>;
	deleteSub: Subscription;

	export$: Observable<boolean | undefined>;
	exportSub: Subscription;

	paging: PaginationParams = {
		size: EXPORT_LIST_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: EXPORT_LIST_DEFAULT_SORT_COLUMN,
		order: EXPORT_LIST_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	pageSizeOptions = EXPORT_LIST_PAGE_SIZE_OPTIONS;
	pageSize = EXPORT_LIST_PAGE_DEFAULT_SIZE;
	resultLength: number;

	totalRecords = 0;

	sort: any;
	// paginator: any;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	COLUMN_TITLE_MIN_WD = 647;

	exportListCsv: MtmaExportData[];
	exportListCsv$: Observable<MtmaExportData[] | undefined>;
	exportListCsvSub: Subscription | undefined;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	currentExportInfo: ExportInfo;

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	@ViewChild(Tooltip) tooltip!: Tooltip;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
		public dialogService: DialogService,
		public confirmationService: ConfirmationService,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		// this.getExportDeviceList();

		this.onResize();
	}

	initSelectors(): void {
		this.exportListLoading$ = this.store.select(selectExportMtmaDeviceListLoading);
		this.exportList$ = this.store.select(selectExportMtmaDeviceList);
		this.exportListPaging$ = this.store.select(selectExportMtmaDevicePaging);
		this.export$ = this.store.select(selectExportedMtmaDevice);
		this.update$ = this.store.select(selectUpdatedMtmaExportDevice);
		this.delete$ = this.store.select(selectDeletedMtmaExportDevice);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.exportListCsv$ = this.store.select(selectMtmaExportData);
		this.currentUser$ = this.store.select(selectUser);
	}

	showHideTooltip() {
		this.tooltip.activate();
	}

	getColumnTitle(): boolean {
		return (this.screenWidth <= this.COLUMN_TITLE_MIN_WD);
	}

	subscribeAll(): void {
		this.exportListLoadingSub = this.exportListLoading$?.subscribe(
			(exportListLoading) => {
				this.exportListLoading = exportListLoading;
			}
		);
		this.exportListSub = this.exportList$?.subscribe(
			(exportList) => {
				this.exportList = exportList;
			}
		);
		this.exportListPagingSub = this.exportListPaging$?.pipe(filter(p => !!p))
			.subscribe(
				paging => {
					if (paging !== null && paging !== undefined) {
						this.totalRecords = paging.TotalCount;
					} else {
						this.totalRecords = 0;
					}
				}
			);
		this.updateSub = this.update$?.subscribe(
			(res) => {
				if (res) {
					this.getExportDeviceList();
				}
			}
		);
		this.exportSub = this.export$?.pipe(filter(res => !!res)).subscribe(
			(res) => {
				if (res) {
					this.getExportDeviceList();
				}
			}
		);
		this.deleteSub = this.delete$?.subscribe(
			(res) => {
				if (res) {
					this.getExportDeviceList();
				}
			}
		);
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.exportListCsvSub = this.exportListCsv$?.subscribe(
			(exportListCsv) => {
				this.exportListCsv = exportListCsv;
				this.exportToCsv();
			}
		);
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
	}

	ngOnDestroy(): void {
		this.exportListLoadingSub?.unsubscribe();
		this.exportListSub?.unsubscribe();
		this.exportListPagingSub?.unsubscribe();
		this.updateSub?.unsubscribe();
		this.exportSub?.unsubscribe();
		this.deleteSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.exportListCsvSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
	}

	getExportDeviceList(): void {
		this.store.dispatch(UserFileActions.getMtmaExportDeviceList({ paging: this.paging, isImpersMode: this.isImpersMode }));
	}

	loadExportDeviceList(event: TableLazyLoadEvent) {
		this.paging = pageSortChange(this.paging, event);

		this.getExportDeviceList();
	}

	importList(exportInfo: ExportInfo): void {
		this.store.dispatch(UserFileActions.resetMtmaImportDeviceDialog());
		this.ref = this.dialogService.open(MtmaImportDeviceDialogComponent, {
			header: this.translate.instant('IMPORT_DATA_INTO_DEVICE'),
			width: '75vw',
			breakpoints: { '1500px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				exportInfo,
			}
		});
	}

	editList(exportInfo: ExportInfo): void {
		this.store.dispatch(UserFileActions.resetMtmaExportDeviceDialog());
		this.ref = this.dialogService.open(MtmaExportDeviceDialogComponent, {
			header: this.translate.instant('EDIT_NAME') + ' ' + this.translate.instant('LIST').toLowerCase(),
			width: '70vw',
			breakpoints: { '1120px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				exportInfo,
			}
		});
	}

	deleteList(exportInfo: ExportInfo): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('EXPORT_DATA_DEVICE_DELETE_TITLE'),
			message: this.translate.instant('EXPORT_DATA_DEVICE_DELETE_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(UserFileActions.deleteMtmaExportDevice({
					exportInfo: exportInfo,
					isImpersMode: this.isImpersMode,
				}));
			},
			reject: () => {
			}
		});
	}

	downloadUrl(url: string, fileName: string) {
		const a: any = document.createElement('a');
		a.href = url;
		a.download = fileName;
		document.body.appendChild(a);
		a.style = 'display: none';
		a.click();
		a.remove();
	}

	// Export csv file management
	exportFile(exportInfo: ExportInfo): void {
		this.acceptButtonStyle = "p-button-primary";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('EXPORT_FILE'),
			message: this.translate.instant('EXPORT_FILE_NOTE_SUBFUNCTIONS') + '<br>' + this.translate.instant('EXPORT_FILE_NOTE_EDIT_AND_IMPORT'),
			acceptLabel: this.translate.instant('EXPORT_FILE'),
			rejectLabel: this.translate.instant('CLOSE'),
			icon: 'pi cm-info',
			accept: () => {
				this.currentExportInfo = exportInfo;
				this.store.dispatch(DeviceActions.getMtmaExportListCsv({ exportListId: exportInfo.Id, userId: this.currentUser.Id }));
				// setTimeout(() => {
				// 	this.store.dispatch(AnalyticsActions.eventNewAction({ eventName: 'export_vct_share_success', params: { page_title: 'List Device | VCT' } }));
				// }, 2000);
			},
			reject: () => {
			}
		});
	}

	prepareColumnsHeader(): any[] {
		const columnRowsHeader = [];
		const row1 = {
			HeaderCol1: 'OPEN_DOOR',
			HeaderCol2: 'G1_OPEN',
			HeaderCol3: 'G1_OPENCLOSE',
			HeaderCol4: 'G1_OUT1',
			HeaderCol5: 'G2_OPEN',
			HeaderCol6: 'G2_OPENCLOSE',
			HeaderCol7: 'G2_OUT1'
		};
		const row2 = {
			HeaderCol1: 'AUX_ON_OFF',
			HeaderCol2: 'G1_OPENTOTAL',
			HeaderCol3: 'G1_SEQUENTIAL',
			HeaderCol4: 'G1_OUT2',
			HeaderCol5: 'G2_OPENTOTAL',
			HeaderCol6: 'G2_SEQUENTIAL',
			HeaderCol7: 'G2_OUT2'
		};
		const row3 = {
			HeaderCol1: 'AUX_ON',
			HeaderCol2: 'G1_OPENPARTIAL',
			HeaderCol3: 'G1_OPENPEDESTRIAN',
			HeaderCol4: 'G1_OUT3',
			HeaderCol5: 'G2_OPENPARTIAL',
			HeaderCol6: 'G2_OPENPEDESTRIAN',
			HeaderCol7: 'G2_OUT3'
		};
		const row4 = {
			HeaderCol1: 'AUX_OFF',
			HeaderCol2: 'G1_CLOSE',
			HeaderCol3: 'G1_STOP',
			HeaderCol4: 'G1_OUT4',
			HeaderCol5: 'G2_CLOSE',
			HeaderCol6: 'G2_STOP',
			HeaderCol7: 'G2_OUT4'
		}
		const row5 = {
			HeaderCol1: '',
			HeaderCol2: '',
			HeaderCol3: '',
			HeaderCol4: '',
			HeaderCol5: '',
			HeaderCol6: '',
			HeaderCol7: ''
		}
		const row6 = {
			HeaderCol1: '----- FILLING OUT -----',
			HeaderCol2: '',
			HeaderCol3: '',
			HeaderCol4: '',
			HeaderCol5: '',
			HeaderCol6: '',
			HeaderCol7: ''
		}
		columnRowsHeader.push(row1);
		columnRowsHeader.push(row2);
		columnRowsHeader.push(row3);
		columnRowsHeader.push(row4);
		columnRowsHeader.push(row5);
		columnRowsHeader.push(row6);
		return columnRowsHeader;
	}

	exportToCsv() {
		if (this.currentExportInfo) {
			const nameFile: string = 'exportMtmaData - ' + this.currentExportInfo.Name;

			// Header infos (rows + columns)
			const infoRows = [];
			infoRows.push(" ----- KEY -----");
			// With ',' inside a row, we obtain a cells split
			infoRows.push("'Type' cells available (just copy and paste):,MTMA_CONTACTS,MTMA_KEYPADS,MTMA_TAGS,MTMA_UNITS");
			infoRows.push("For required fields: enter values within '##**', (after '##' and before '**')");
			infoRows.push("For optional fields: leave cells blank");
			infoRows.push("Required fields for Type MTMA_CONTACTS:,Name,Description,Phone,Action1,Action2,Group");
			infoRows.push("Required fields for Type MTMA_KEYPADS:,Description,KeypadTagCode,Action1,Action2,Group");
			infoRows.push("Required fields for Type MTMA_TAGS:,Description,KeypadTagCode,Action1,Action2,Group");
			infoRows.push("Required fields for Type MTMA_UNITS:,Name,Description,UnitCode,Contact1,Contact2,Contact3,Contact4,Contact5");
			infoRows.push(",,"); // dont remove ',' we need to count also this row empty after on import
			infoRows.push("List of actions available");

			const mapHeaderColumnsInfo = new Map();
			mapHeaderColumnsInfo.set("HeaderCol1", 'Actions Inputs/Outputs');
			mapHeaderColumnsInfo.set("HeaderCol2", 'Actions Automation1');
			mapHeaderColumnsInfo.set("HeaderCol3", 'Actions Automation1');
			mapHeaderColumnsInfo.set("HeaderCol4", 'Actions Automation1');
			mapHeaderColumnsInfo.set("HeaderCol5", 'Actions Automation2');
			mapHeaderColumnsInfo.set("HeaderCol6", 'Actions Automation2');
			mapHeaderColumnsInfo.set("HeaderCol7", 'Actions Automation2');
			const infoColumns = this.prepareColumnsHeader();

			// Header row file data
			const map = new Map();
			map.set("Type", 'Type');
			map.set("Name", 'Name');
			map.set("Description", 'Description');
			map.set("Phone", 'Phone');
			map.set("UnitCode", 'UnitCode');
			map.set("KeypadTagCode", 'KeypadTagCode');
			map.set("Action1", 'Action1');
			map.set("Action2", 'Action2');
			map.set("Group", 'Group');
			map.set("Contact1", 'Contact1');
			map.set("Contact2", 'Contact2');
			map.set("Contact3", 'Contact3');
			map.set("Contact4", 'Contact4');
			map.set("Contact5", 'Contact5');

			// file data
			const data = this.prepareDataForLogs();

			exportToCsvWithInfoColumn(data, nameFile, map, infoRows, infoColumns, mapHeaderColumnsInfo);
		}
	}

	prepareDataForLogs(): MtmaExportRow[] {
		const list = [];
		this.exportListCsv.forEach(exportRowCsv => {
			list.push(this.prepareDataForLogTypeRow(exportRowCsv))
		});
		return list;
	}

	prepareDataForLogTypeRow(exportRowCsv: MtmaExportData): MtmaExportRow {
		const type = exportRowCsv.Type
		switch (type) {
			case 'MTMA_CONTACTS':
				return this.prepareDataForLogTypeContacts(exportRowCsv);
			case 'MTMA_UNITS':
				return this.prepareDataForLogTypeUnits(exportRowCsv);
			case 'MTMA_KEYPADS':
				return this.prepareDataForLogTypeKeypadsTags(exportRowCsv);
			case 'MTMA_TAGS':
				return this.prepareDataForLogTypeKeypadsTags(exportRowCsv);
			default:
				return new MtmaExportRow();
		}
	}

	prepareDataForLogTypeContacts(exportRowCsv: MtmaExportData): MtmaExportRow {
		const mtmaExportRow = new MtmaExportRow();
		mtmaExportRow.Type = exportRowCsv.Type;
		mtmaExportRow.Name = '##' + (exportRowCsv.Name ? exportRowCsv.Name : '') + '**';
		mtmaExportRow.Description = '##' + (exportRowCsv.Description ? exportRowCsv.Description : '') + '**';
		mtmaExportRow.Phone = '##' + (exportRowCsv.Phone ? exportRowCsv.Phone : '') + '**';
		mtmaExportRow.UnitCode = '';
		mtmaExportRow.KeypadTagCode = '';
		mtmaExportRow.Action1 = '##' + (exportRowCsv.Action1 ? exportRowCsv.Action1 : '') + '**';
		mtmaExportRow.Action2 = '##' + (exportRowCsv.Action2 ? exportRowCsv.Action2 : '') + '**';
		mtmaExportRow.Group = '##' + (exportRowCsv.RuleName ? exportRowCsv.RuleName : '') + '**';
		mtmaExportRow.Contact1 = '';
		mtmaExportRow.Contact2 = '';
		mtmaExportRow.Contact3 = '';
		mtmaExportRow.Contact4 = '';
		mtmaExportRow.Contact5 = '';
		return mtmaExportRow;
	}

	prepareDataForLogTypeUnits(exportRowCsv: MtmaExportData): MtmaExportRow {
		const mtmaExportRow = new MtmaExportRow();
		mtmaExportRow.Type = exportRowCsv.Type;
		mtmaExportRow.Name = '##' + (exportRowCsv.Name ? exportRowCsv.Name : '') + '**';
		mtmaExportRow.Description = '##' + (exportRowCsv.Description ? exportRowCsv.Description : '') + '**';
		mtmaExportRow.Phone = '';
		mtmaExportRow.UnitCode = '##' + (exportRowCsv.KeyboardCode ? exportRowCsv.KeyboardCode : '') + '**';
		mtmaExportRow.KeypadTagCode = '';
		mtmaExportRow.Action1 = '';
		mtmaExportRow.Action2 = '';
		mtmaExportRow.Group = '';
		mtmaExportRow.Contact1 = '##' + (exportRowCsv.Contact1Name ? exportRowCsv.Contact1Name : '') + '**';
		mtmaExportRow.Contact2 = '##' + (exportRowCsv.Contact2Name ? exportRowCsv.Contact2Name : '') + '**';
		mtmaExportRow.Contact3 = '##' + (exportRowCsv.Contact3Name ? exportRowCsv.Contact3Name : '') + '**';
		mtmaExportRow.Contact4 = '##' + (exportRowCsv.Contact4Name ? exportRowCsv.Contact4Name : '') + '**';
		mtmaExportRow.Contact5 = '##' + (exportRowCsv.Contact5Name ? exportRowCsv.Contact5Name : '') + '**';
		return mtmaExportRow;
	}

	prepareDataForLogTypeKeypadsTags(exportRowCsv: MtmaExportData): MtmaExportRow {
		const mtmaExportRow = new MtmaExportRow();
		mtmaExportRow.Type = exportRowCsv.Type;
		mtmaExportRow.Name = '';
		mtmaExportRow.Description = '##' + (exportRowCsv.Description ? exportRowCsv.Description : '') + '**';
		mtmaExportRow.Phone = '';
		mtmaExportRow.UnitCode = '';
		mtmaExportRow.KeypadTagCode = '##' + (exportRowCsv.Code ? exportRowCsv.Code : '') + '**';
		mtmaExportRow.Action1 = '##' + (exportRowCsv.Action1 ? exportRowCsv.Action1 : '') + '**';
		mtmaExportRow.Action2 = '##' + (exportRowCsv.Action2 ? exportRowCsv.Action2 : '') + '**';
		mtmaExportRow.Group = '##' + (exportRowCsv.RuleName ? exportRowCsv.RuleName : '') + '**';
		mtmaExportRow.Contact1 = '';
		mtmaExportRow.Contact2 = '';
		mtmaExportRow.Contact3 = '';
		mtmaExportRow.Contact4 = '';
		mtmaExportRow.Contact5 = '';
		return mtmaExportRow;
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}
}